import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Team, Previous, Developer, Lead } from './ourteam';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';

const TITLE = 'KnowQuest';

function About() {
  const [loading, setLoading] = useState(true);
  const [aboutData, setAboutData] = useState(null); // Store structured policy data
  const server_url = process.env.REACT_APP_API_URI;

  const fetchabout = async () => {
    try {
      const response = await axios.get(
        `${server_url}/content/get-content/67c9a7a0e2ffe9900d9db862`,
      );
      console.log(response);

      if (response.data && response.data.data) {
        setAboutData(response.data.data); // Store structured data
      } else {
        setAboutData(null);
      }
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setAboutData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchabout();
  }, []);
  return (
    <>
      {/* <Helmet>
        <title>{TITLE}</title>
      </Helmet> */}
      <div className="max-w-screen-xl mx-auto px-5 lg:px-20 xl:px-24 py-12">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8">
          {loading ? (
            <p className="text-white">Loading...</p>
          ) : aboutData ? (
            <div>
              {aboutData && (
                <div className="lg:w-full">
                  {/* <h1 className="text-3xl font-bold text-white mb-4">
                    {aboutData.mainTitle || 'About KnowQuest'}
                  </h1> */}
                  <h1 className="text-4xl font-bold text-white text-center mb-6">
                    {aboutData?.mainTitle || 'Contact Us'}
                  </h1>
                  {aboutData.sections?.map((section, index) => (
                    <div key={index} className="mb-6">
                      {section.contents.map((content) => (
                        <div
                          key={content._id}
                          dangerouslySetInnerHTML={{ __html: content.content }}
                          className="text-gray-300 text-justify leading-relaxed [&>p]:mb-3 [&>ul]:list-disc [&>ul]:ml-6 [&>ol]:list-decimal [&>ol]:ml-6"
                        />
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <p className="text-white">No about data available.</p>
          )}
        </div>

        {/* Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-6 lg:mx-8">
          {/* Vision and Mission Cards */}
          {[
            {
              title: 'Our Vision',
              description:
                'To be the default academic feedback platform in the world.',
            },
            {
              title: 'Our Mission',
              description:
                'We bridge the gap between professors, students, schools, and publishers.',
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-gray-900 shadow-lg rounded-xl overflow-hidden transition-transform transform hover:scale-105"
            >
              <div className="p-4">
                <h3 className="text-2xl font-bold text-secondary mb-3">
                  {item.title}
                </h3>
                <p className="text-white leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Our Team Section */}
        <div className="mt-16">
          <h2 className="text-4xl font-extrabold text-center mb-12 text-white">
            Meet Our Team
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 mx-5 lg:mx-0 gap-8">
            {Team.map((member, index) => (
              <div
                key={index}
                className="bg-gray-900 shadow-xl rounded-2xl overflow-hidden p-8 text-center transform transition duration-300 hover:scale-105 h-full flex flex-col justify-between"
              >
                <div>
                  <img
                    className="w-36 h-36 mx-auto rounded-full object-cover border-4 border-secondary"
                    src={member.img}
                    alt={member.name}
                  />
                  <h3 className="text-2xl font-bold text-white mt-6">
                    {member.name}
                  </h3>
                  <p className="text-gray-500 text-lg mt-2">{member.role}</p>
                </div>
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center mt-4 text-white bg-secondary  px-4 py-2 rounded-lg transition-colors"
                  >
                    Connect on LinkedIn
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Developed By Section */}
        <div className="mt-16">
          <h2 className="text-3xl font-bold text-center mb-8 text-white">
            Developed By
            <br />
            <span className="text-2xl">Jan 2023 - May 2023 Teams</span>
          </h2>

          {/* Lead Section */}
          <div className="flex justify-center items-center gap-8  my-6">
            {Lead.map((member, index) => (
              <div
                key={index}
                className="bg-gray-900 shadow-lg rounded-xl p-6 transition-transform transform hover:scale-105 w-72 flex flex-col items-center justify-between text-center h-80"
              >
                {member.img ? (
                  <img
                    className="w-32 h-32 rounded-full object-cover border-4 border-secondary"
                    src={member.img}
                    alt={member.name}
                  />
                ) : (
                  <PersonIcon
                    sx={{ width: 128, height: 128 }}
                    className="text-gray-500"
                  />
                )}
                <h3 className="text-xl font-semibold text-white mt-4">
                  {member.name}
                </h3>
                <p className="text-gray-400">{member.role}</p>
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-4 text-white bg-secondary  px-4 py-2 rounded-lg "
                  >
                    Connect on LinkedIn
                  </a>
                )}
              </div>
            ))}
          </div>

          {/* Developer Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 mx-5 lg:mx-0 gap-8">
            {Developer.map((member, index) => (
              <div
                key={index}
                className="bg-gray-900 shadow-lg rounded-xl p-6 w-full flex flex-col items-center transform transition duration-300 hover:scale-105 justify-between text-center h-80"
              >
                {member.img ? (
                  <img
                    className="w-32 h-32 rounded-full object-cover border-4 border-secondary"
                    src={member.img}
                    alt={member.name}
                  />
                ) : (
                  <PersonIcon
                    sx={{ width: 128, height: 128 }}
                    className="text-gray-500"
                  />
                )}
                <h3 className="text-xl font-semibold text-white mt-4">
                  {member.name}
                </h3>
                <p className="text-gray-400">{member.role}</p>
                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-4 text-white bg-secondary  px-4 py-2 rounded-lg  "
                  >
                    Connect on LinkedIn
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Developed By Section */}
        <div className="mt-16">
          <h2 className="text-4xl font-extrabold text-center mb-12 text-white">
            Previous Team
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {Previous.map((member, index) => (
              <div
                key={index}
                className="bg-gray-900 shadow-xl rounded-2xl overflow-hidden p-6 mx-5 lg:mx-0 text-center transform transition duration-300 hover:scale-105 
                flex flex-col items-center justify-between h-full"
              >
                {member.img ? (
                  <img
                    className="w-32 h-32 rounded-full object-cover border-4 border-secondary"
                    src={member.img}
                    alt={member.name}
                  />
                ) : (
                  <PersonIcon
                    sx={{ width: 128, height: 128 }}
                    className="rounded-full object-cover text-gray-400"
                  />
                )}

                <h3 className="text-2xl font-bold text-white mt-6">
                  {member.name}
                </h3>
                <p className="text-gray-400 text-base mt-2">{member.role}</p>

                {member.linkedin && (
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-4 text-white bg-secondary  px-4 py-2 rounded-lg "
                  >
                    Connect on LinkedIn
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
